module.exports = __webpack_public_path__ + "static/embajada-de-australia-427875ac5d506e8d91e8e9cb94e59c2d.png";